import { useState } from "react";
import {
  createNewVoucherService,
  deleteVoucherService,
  editVoucherService,
  enableDisableVoucherService,
  getVoucherListService,
} from "../../../api/Vouchers";
import {message} from 'antd'

const useVouchers = () => {
  const [vouchers, setVouchers] = useState([]);

  const getVoucherList = async (page = 1) => {
    try {
      const res = await getVoucherListService(page);
      setVouchers(res.data || []);
    } catch (error) {
      console.error("Error fetching voucher list:", error);
    }
  };

  const onSaveVoucher = async (data) => {
    const functionToExecute = data?.coupon_id
      ? editVoucherService
      : createNewVoucherService;
    const messageToShow = data?.id
      ? "Cupón editado exitosamente"
      : "Cupón creado exitosamente";
    const response = await functionToExecute(data);

    if (response.status === 200) {
      message.success(messageToShow);
      return true;
    }
    message.error(
      response?.error?.response?.data?.message || response?.error?.message
    );
    return false;
  };

  const enableDisableVoucher = async (coupon_id) => {
    const response = await enableDisableVoucherService(coupon_id);
    if (response.status === 200) {
      message.success("Estatus del cupón actualizado exitosamente");
      return true;
    }
    message.error(
      response?.error?.response?.data?.message || response?.error?.message
    );
    return false;
  };

  const deleteVoucher = async (coupon_id) => {
    const response = await deleteVoucherService(coupon_id);
    if (response.status === 200) {
      message.success("Cupón eliminado exitosamente");
      return true;
    }
    message.error(
      response?.error?.response?.data?.message || response?.error?.message
    );
    return false;
  };

  return {
    vouchers,
    getVoucherList,
    enableDisableVoucher,
    deleteVoucher,
    onSaveVoucher
  };
};

export default useVouchers;
